import Vue from 'vue'

// If the dropdowns are nested we need to queue them and pop them of off the stack one by one.
// Using Vue because of computed properties and reactivity model. Has stack interface (push/pop/empty/current)
const dropdowns = new Vue({
  data: {
    elements: [],
  },

  computed: {
    current () {
      if (this.empty) {
        throw new Error('No current popup available')
      } else {
        return this.elements[0]
      }
    },
    empty () {
      return this.elements.length == 0
    },
  },

  methods: {
    push (el, close) {
      if (!(el && close)) {
        throw new Error('To open a dropdown you need to pass both the root el and a close handler')
      }
      this.elements.unshift({ el, close })
    },
    pop () {
      if (this.empty) {
        throw new Error('The list of dropdowns is empty')
      }
      return this.elements.shift()
    },
  },
})

window.dropdowns = dropdowns

// Event handlers

function clickOutsideDropdownEventHandler (e) {
  if (!dropdowns.empty) {
    log.debug('AutoCloseMixin/clickOutsideDropdownEventHandler current', dropdowns.current, 'e.target', e.target)
    let node = e.target
    while (node) {
      if (node === dropdowns.current.el) return
      node = node.parentNode
    }
    log.debug('AutoCloseMixin.clickOutsideDropdownEventHandler closing', dropdowns.current)
    // E.stopPropagation()
    // e.preventDefault()
    dropdowns.pop().close()
  }
}

function closeOnEscKeyDownEventHandler (e) {
  if (e.code == 'Escape' && !dropdowns.empty) {
    log.debug('AutoCloseMixin.closeOnEscKeyDownEventHandler', dropdowns.current)
    e.stopPropagation()
    e.preventDefault()
    dropdowns.pop().close()
  }
}

document.addEventListener('click', clickOutsideDropdownEventHandler, { capture: true })
document.addEventListener('keydown', closeOnEscKeyDownEventHandler, { capture: true })

export class AutoCloseMixin {
  constructor (el, close = this.close) {
    this.el = el
    dropdowns.push(el, close)
  }

  close () {
    log.debug('Pass me a "close" method to perform action when the dropdown is closed')
  }

  cleanup () {
    // This is a method that ensures that if there was no clean close of the
    // dropdown that it is properly removed from the stack.
    if (!dropdowns.empty && dropdowns.current.el === this.el) {
      dropdowns.pop()
    }
  }
}

export default {
  props: {
    // This is used to initiate closing action when clicked outside of the dropdown
    // to determine if the element should be considered as part of the dropdown or not.
    // It is mainly used with calendar when the input box has the ability to switch
    // modes (start, end) the calendar should be in.
    autoCloseParent: {
      type: HTMLElement,
      required: false,
      default: null,
    },
  },

  mounted () {
    log.debug('AutoCloseMixin.mounted', this.autoCloseParent || this.$el)
    this.autoCloseMixin = new AutoCloseMixin(this.autoCloseParent || this.$el, this.close)
  },

  destroyed () {
    this.autoCloseMixin.cleanup()
  },

  methods: {
    close () {
      this.$emit('close')
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/AutoCloseMixin.js